import { createSlice } from "@reduxjs/toolkit";
import {
  fetchStudents,
  addStudent,
  updateStudent,
  deleteStudent,
} from "./student.thunk";

const initialState = {
  students: [],
  totalPages: 1,
  currentPage: 1,
  total: 0,
  limit: 10,
  loading: false,
  error: null,
  selectedStudent: null,
};

const studentSlice = createSlice({
  name: "students",
  initialState,

  reducers: {
    setCurrentPage: (state, action) => {
      state.currentPage = action.payload;
    },
    setSelectedStudent: (state, action) => {
      state.selectedStudent = action.payload;
    },
    clearSelectedStudent: (state) => {
      state.selectedStudent = null;
    },
  },

  extraReducers: (builder) => {
    builder

      /* ===== FETCH ===== */
      .addCase(fetchStudents.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchStudents.fulfilled, (state, action) => {
        state.loading = false;
        state.students = action.payload.data;
        state.totalPages = action.payload.meta.total_pages;
        state.total = action.payload.meta.total;
        state.limit = action.payload.meta.limit;
      })
      .addCase(fetchStudents.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      /* ===== ADD ===== */
      .addCase(addStudent.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(addStudent.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      /* ===== UPDATE ===== */
      .addCase(updateStudent.fulfilled, (state) => {
        state.loading = false;
      })

      /* ===== DELETE ===== */
      .addCase(deleteStudent.fulfilled, (state, action) => {
        state.students = state.students.filter(
          (student) => student.id !== action.payload.id
        );
      });
  },
});

export const {
  setCurrentPage,
  setSelectedStudent,
  clearSelectedStudent,
} = studentSlice.actions;

export default studentSlice.reducer;
